import {Button, Card} from 'platform/components';
import {Heading, HStack, Show, Text, VStack} from 'platform/foundation';

import i18n from '@dms/i18n';

interface FinancingEmptyStateProps {
  canReadTemplates: boolean;
  isAutomaticFinancingOffered: boolean;
  isCreateAllowed: boolean;
  isUpdateAllowed: boolean;
  isActivatingAutomatic: boolean;
  onUseAutomatic: () => void;
  onCreateTemplate: () => void;
  onConfigureManually: () => void;
}

export function FinancingEmptyState(props: FinancingEmptyStateProps) {
  const createTemplateVariant = props.isAutomaticFinancingOffered ? 'secondary' : 'primary';
  const configureManuallyVariant =
    props.canReadTemplates || props.isAutomaticFinancingOffered ? 'secondary' : 'primary';

  return (
    <Card variant="inlineGrey">
      <VStack spacing={4} align="center">
        <Heading size={4}>{i18n.t('page.vehicle.financingAndLeasing.noFinancing')}</Heading>
        <Text color="secondary">
          {i18n.t('page.vehicle.financingAndLeasing.noFinancingExplanation')}
        </Text>
        <HStack spacing={2} wrap justify="center">
          <Show when={props.isAutomaticFinancingOffered}>
            <Button
              title={i18n.t('page.vehicle.financingAndLeasing.useAutomaticFinancing')}
              variant="primary"
              isLoading={props.isActivatingAutomatic}
              isDisabled={!props.isUpdateAllowed}
              onClick={props.onUseAutomatic}
            />
          </Show>
          <Show when={props.canReadTemplates}>
            <Button
              title={i18n.t('entity.vehicleFinancingTemplate.actions.createTemplate')}
              variant={createTemplateVariant}
              isDisabled={!props.isCreateAllowed}
              onClick={props.onCreateTemplate}
            />
          </Show>
          <Button
            title={i18n.t('page.vehicle.financingAndLeasing.configureManually')}
            variant={configureManuallyVariant}
            isDisabled={!props.isCreateAllowed}
            onClick={props.onConfigureManually}
          />
        </HStack>
      </VStack>
    </Card>
  );
}
